import {createVoidActionCreator} from '../common/actions';

export const ExpandMegaMenu = createVoidActionCreator('EXPAND_MEGA_MENU');
export const CollapseMegaMenu = createVoidActionCreator('COLLAPSE_MEGA_MENU');

export const ToggleMegaMenu = createVoidActionCreator('TOGGLE_MEGA_MENU');
